
import React from "react"

import { PlusOutlined } from "@ant-design/icons"
import { RBHButton } from "../../../../shared/components"
import { Colors } from "../../../../shared/theme"
import { textStyles } from "../../../../shared/theme/fonts-ppv"

const AddButton = ({ 
    onClick,
    style,
    id,
    text,
    disabled = false,
}: { 
    id: string,
    text: string,
    disabled?: boolean,
    style?: React.CSSProperties,
    onClick?: () => void 
}) => {
    return (
        <RBHButton
            id={id}
            data-testid={id}
            style={{
                ...textStyles.subtitle2,
                color: Colors.white,
                borderRadius: '48px',
                borderColor: Colors.violet600,
                background: Colors.violet600,
                ...style,
            }}
            text={text}
            type='primary'
            onClick={onClick}
            icon={<PlusOutlined translate={null} />}
            disabled={disabled}
        />
    )
}

export default AddButton;